export default __webpack_public_path__ + "static/media/After Dark.893c75d2.mp3";